'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../enums/accordion.js');
require('../enums/alert.js');
require('../enums/avatar.js');
require('../enums/breakpoints.js');
require('../enums/button.js');
require('../enums/code-editor.js');
var colors = require('../enums/colors.js');
require('../enums/combobox.js');
require('../enums/date.js');
require('../enums/drag-and-drop.js');
require('../enums/dialog.js');
require('../enums/divider.js');
require('../enums/dropdown.js');
require('../enums/fieldset.js');
require('../enums/font-icon.js');
require('../enums/fonts.js');
require('../enums/headings.js');
require('../enums/input.js');
require('../enums/keys.js');
require('../enums/list.js');
require('../enums/listbox.js');
require('../enums/loader.js');
require('../enums/margin.js');
require('../enums/option.js');
require('../enums/pill.js');
require('../enums/placements.js');
require('../enums/popout.js');
require('../enums/privacy.js');
require('../enums/radio-group.js');
require('../enums/status.js');
require('../enums/switch.js');
require('../enums/table.js');
require('../enums/tooltip.js');
require('../enums/transitions.js');
require('../enums/widths.js');

const defaultAlert = {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: colors.BrandfolderHexColors.Text,
    iconColorHover: colors.BrandfolderHexColors.Title,
    textColor: colors.BrandfolderHexColors.Text,
    textColorInline: colors.BrandfolderHexColors.Text
};
const defaultAlertDark = {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: colors.BrandfolderHexColors.White,
    iconColorHover: colors.BrandfolderHexColors.Gray,
    textColor: colors.BrandfolderHexColors.White,
    textColorInline: colors.BrandfolderHexColors.White
};
const errorAlert = {
    backgroundColor: '#FFE3E4',
    borderColor: '#FE999C',
    iconColor: colors.BrandfolderHexColors.Delete,
    iconColorHover: '#9D0214',
    textColor: colors.BrandfolderHexColors.Text,
    textColorInline: colors.BrandfolderHexColors.Delete
};
const errorAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#FE999C',
    iconColor: colors.BrandfolderHexColors.Delete,
    iconColorHover: '#9D0214',
    textColor: colors.BrandfolderHexColors.White,
    textColorInline: colors.BrandfolderHexColors.Delete
};
const successAlert = {
    backgroundColor: '#D3F9E7',
    borderColor: '#77EDB6',
    iconColor: '#00A042',
    iconColorHover: '#006D2D',
    textColor: colors.BrandfolderHexColors.Text,
    textColorInline: '#00A042'
};
const successAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#77EDB6',
    iconColor: '#00A042',
    iconColorHover: '#006D2D',
    textColor: colors.BrandfolderHexColors.White,
    textColorInline: '#00A042'
};
const warningAlert = {
    backgroundColor: '#FFF7DC',
    borderColor: '#FFE796',
    iconColor: '#D39F00',
    iconColorHover: '#A07900',
    textColor: colors.BrandfolderHexColors.Text,
    textColorInline: '#D39F00'
};
const warningAlertDark = {
    backgroundColor: 'transparent',
    borderColor: '#FFE796',
    iconColor: '#D39F00',
    iconColorHover: '#A07900',
    textColor: colors.BrandfolderHexColors.White,
    textColorInline: '#D39F00'
};

exports.defaultAlert = defaultAlert;
exports.defaultAlertDark = defaultAlertDark;
exports.errorAlert = errorAlert;
exports.errorAlertDark = errorAlertDark;
exports.successAlert = successAlert;
exports.successAlertDark = successAlertDark;
exports.warningAlert = warningAlert;
exports.warningAlertDark = warningAlertDark;
//# sourceMappingURL=alert.js.map
